import React from "react";

const SiteCell = ({ row }) => {
  return <div>{row.siteName}</div>;
};

export default SiteCell;
